import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ExtensionForm } from '../extension-form';
import { createExtension } from '../../actions';
import { useHistory } from '../../../../components/navigation';
export const AdminExtensionCreate = () => {
    const [disableBtn, setDisableBtn] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const handleSave = async (data) => {
        setDisableBtn(true);
        await dispatch(createExtension(data));
        setDisableBtn(false);
        history.push(`/account/admin/extensions/list`);
    };
    return (<div>
      <header className="settings-header">
        <h2 className="header-title">
          <FormattedMessage id="account.administration.extentions.create-extension-title"/>
        </h2>
      </header>
      <div>
        <ExtensionForm onSave={handleSave} disableSubmitBtn={disableBtn}/>
      </div>
    </div>);
};
